<template>
  <div>
    <Row style="width: 100%;margin-top:110px">
      <Col span="24" class="backImg">
        <img :src="img" width="100%" />
      </Col>
    </Row>

    <Row style="margin-bottom: 180px;">
      <Col span="8" style="margin-left: 210px;">
        <img :src="img2" width="70%" height="60%" style="vertical-align: bottom; margin-top:70px" />
      </Col>
      <Col span="6" style="margin-left: 140px;">
        <Row
          style="color: #245580;font-size: 35px;font-weight: bold;letter-spacing: 10px;margin-top: 120px;margin-bottom: 20px;"
        >泽达品牌</Row>
        <Row
          style="color:#686868;font-size:22px;line-height: 40px;letter-spacing:5px;width: 100%;margin-left:px;text-align: justify"
        >
          <p>北龙泽达（北京）数据科技有限公司（简称“北龙泽达”）成立于2000 年5月8日，是一家高新技术企业，以国家级数据中心服务经验为基础，围绕大数据的产业发展中的规模性、高速性、多样性等复杂性问题，针对大数据分析处理技术的迫切需求，持续汇聚多形态数据资源，融合多形态测试基准程序，开展大数据融合管理与关联发现、大数据分析挖掘与快速处理、支持大数据核心软件及系统基准测试等关键技术的研究，建设基于云计算的大数据分析与计算关键技术研发平台、支撑大数据分析与计算的核心算法、软件及系统测试平台、大数据分析与计算技术验证平台。目前已在面向保险领域的“车险理赔智能风控系统”和面向油气领域的“油气数智一体化平台”建设和服务中广泛应用，致力于服务国家工业互联网快速发展，用数据驱动未来。</p>
        </Row>
      </Col>
    </Row>

    <Row :gutter="0" style="margin-left:210px;">
      <Col span="5">
        <img :src="img3" width="25%" height="15%" />
        <br />
        <br />
        <h3>100+客户</h3>
        <br />
        <br />
      </Col>
      <Col span="5">
        <img :src="img4" width="25%" height="15%" />
        <br />
        <br />
        <h3>250+项目完成</h3>
        <br />
        <br />
      </Col>
      <Col span="5">
        <img :src="img5" width="25%" height="15%" />
        <br />
        <br />
        <h3>100+重视伙伴</h3>
        <br />
        <br />
      </Col>
      <Col span="5">
        <img :src="img6" width="25%" height="15%" />
        <br />
        <br />
        <h3>6+服务国家</h3>
        <br />
        <br />
      </Col>
    </Row>

    <Row style="display: flex;justify-content: center;margin-top:110px;margin-bottom:60px">
      <Col span="24" class="title">
        <span>所获荣誉</span>
        <br />
      </Col>
    </Row>

    <Row
      :gutter="66"
      style="display: flex;justify-content: center;margin-top:110px;margin-bottom:60px"
    >
      <Col span="5">
        <img :src="img7" width="100%" />
      </Col>
      <Col span="5">
        <img :src="img8" width="100%" />
      </Col>
      <Col span="5">
        <img :src="img9" width="100%" />
      </Col>
      <Col span="5">
        <img :src="img10" width="100%" />
      </Col>
    </Row>

    <Row style="display: flex;justify-content: center;margin-top:110px;margin-bottom:60px">
      <Col span="24" class="title">
        <span>合作单位</span>
        <br />
      </Col>
    </Row>

    <Row
      :gutter="20"
      style="display: flex;justify-content: center;margin-top:110px;margin-bottom:60px"
    >
      <Col span="5">
        <img :src="img14" />
      </Col>
      <!--<Col span="5">
            <img :src="img11">
         
      </Col>-->
      <Col span="5">
        <img :src="img12" />
      </Col>
      <Col span="5">
        <img :src="img13" />
      </Col>
    </Row>

    <!--<Row style="width: 100%;">
      <Col span="24">
        <div
          style="position:relative;bottom:-200px;left:1100px;background: #4f4a9b;height: 210px;width:420px;color:white;font-size:20px;"
        >
          <br />
          <br />
          <span>公司名称：北龙泽达（北京）数据科技有限公司</span>
          <br />
          <span>地址：北京市怀柔区永乐北一街3号院5号楼二层201室-229</span>
          <br />
          <span style="text-align: left;">联系邮箱：jia.zhonglong@tudb.ai</span>
          <br />
        </div>
        <div style="background: #161e6d;height: 210px; color:white;font-size:20px;">
          <div style="margin-left: 380px;margin-top: 120px;">
            <br />
            <br />
          </div>
        </div>
      </Col>
    </Row>-->
  </div>
</template>
<script>
export default {
  data() {
    return {
      info: 23923,
      bid: 115486,
      money: 16745305.75,
      noticeList: [],
      data1: [],
      data2: [],
      data3: [],
      data4: [],
      img: "../../../../static/officeImg/index/bannerContact.webp",
      img2: "../../../../static/officeImg/gas/101.png",
      img3: "../../../../static/officeImg/contact/1.png",
      img4: "../../../../static/officeImg/contact/2.png",
      img5: "../../../../static/officeImg/contact/3.png",
      img6: "../../../../static/officeImg/contact/4.png",
      img7: "../../../static/officeImg/contact/01.png",
      img8: "../../../static/officeImg/contact/02.png",
      img9: "../../../static/officeImg/contact/03.png",
      img10: "../../../static/officeImg/contact/04.png",
      img11: "../../../static/officeImg/unit/cooperation1.png",
      img12: "../../../static/officeImg/unit/cooperation2.png",
      img13: "../../../static/officeImg/unit/cooperation3.png",
      img14: "../../../static/officeImg/unit/cooperation4.png",
      // img15: "../../../static/officeImg/contact/01.png",
    };
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm");
    },
  },
  mounted() {
    this.loadData();
    //千位分割符
    this.money = this.toThousands(this.money, 2);
  },
  methods: {
    loadData: function () {},
    Goto: function (type, id) {
      switch (type) {
        case "C01":
          {
            this.$router.push({ name: "detail", query: { detailId: id } });
          }
          break;
        case "C02":
          {
            this.$router.push({ name: "detail2", query: { detailId: id } });
          }
          break;
        case "C03":
          {
            this.$router.push({ name: "detail1", query: { detailId: id } });
          }
          break;
        case "C04":
          {
            this.$router.push({ name: "detail3", query: { detailId: id } });
          }
          break;
        default:
          break;
      }
    },
    more: function () {
      this.$router.push({ path: "/item" });
    },
    //千位分割符
    toThousands: function (num, n, separator) {
      let parts;
      num = num + "";
      // 判断是否为数字
      if (!isNaN(parseFloat(num)) && isFinite(num)) {
        let nx;
        nx = Math.pow(10, n);

        num = (Math.round(num * nx) / nx).toFixed(n);

        parts = num.split(".");
        parts[0] = parts[0]
          .toString()
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + (separator || ","));

        return parts.join(".");
      }
      return NaN;
    },
  },
};
</script>
<style scoped>
.backImg {
  background-color: white;
  width: 100%;
  font-size: 25px;
  text-align: center;
  line-height: 30px;
  color: red;
  margin-top: 0px;
  margin-left: 0px;
}
.ImgLocal {
  position: relative;
  left: 180px;
  margin-top: 40px;
}
.FontLocal {
  margin-top: 60px;
}
.title {
  text-align: center;
  color: rgb(0, 0, 0);
  font-size: 23px;
  line-height: 40px;
  padding: 1% 0px;
}
.li2 {
  width: 50%;
  font-size: 15px;
  margin-top: 6px;
}
.numInfo {
  background: white;
  font-size: larger;
  font-family: 微软雅黑;
  height: 100px;
  padding: 20px;
  box-shadow: 0.5px 0.5px 3px 0.5px darkgray;
}
.baseCard {
  background: white;
  font-family: 微软雅黑;
  box-shadow: 0.5px 0.5px 3px 0.5px darkgray;
}
.cardTitle {
  text-align: left;
  font-weight: 540 !important;
  color: orange;
}

.li3 {
  width: 43%;
  font-size: 12px;
}
.icon-shuxian {
  font-size: 20px;
}
.shuxian {
  display: inline-block;
  width: 4px;
  height: 22px;
  background: orange;
}
.icon-gengduo {
  color: orange;
}
.gengduo {
  font-family: 微软雅黑;
  color: rgb(120, 122, 123);
  font-size: 15px;
}
.wailian {
  font-size: 15px;
  font-weight: 540;
  color: #787a7b;
}
</style>



// WEBPACK FOOTER //
// src/views/connectData/connectData.vue